<nz-header
  id="secondaryHeader"
  class="regular"
  *ngIf="showSecondaryHeader"
  [ngClass]="{
    large: fBarPages.includes(pageName),
    labs_secondary_header: isLabsPage
  }"
>
  <!--ToDo Page name change-->
  <div
    style="height: 100%"
    nz-row
    nzType="flex"
    nzJustify="start"
    nzAlign="small"
  >
    <div nz-col nzSpan="24">
      <div nz-row nzType="flex" nzJustify="space-between">
        <div nz-col>
          <app-subheader-breadcrumb></app-subheader-breadcrumb>
          <span id="secondaryHeaderTitle">
            <a
              *ngIf="link && link.length > 0"
              routerLink="{{ link }}"
              routerLinkActive="active"
              >{{ title }}</a
            >
            <span *ngIf="link.length == 0">{{ title }}</span>
          </span>
          <span id="secondaryHeaderTicker">
            <a
              *ngIf="link.length > 0"
              routerLink="{{ link }}"
              routerLinkActive="active"
              >{{ sup }}</a
            >
            <span *ngIf="link.length == 0">{{ sup }}</span>
          </span>
          <app-subheader-company-notes
            *ngIf="showCompanyNotes"
            [ticker]="ticker"
          ></app-subheader-company-notes>
        </div>
        <div nz-col>
          <ng-container
            *ngIf="labParams && showLabMenuButton && labs_menu_access"
          >
            <app-labs-page-nav
              [labsPagesParams]="labParams"
            ></app-labs-page-nav>
          </ng-container>
          <button
            *ngIf="showWatchlist"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link watchlist-button"
            [ngClass]="{ 'btn-secondary-header-active': watchlistMenuVisible }"
            nz-dropdown
            nzTrigger="click"
            [nzDropdownMenu]="menu"
            [(nzVisible)]="watchlistMenuVisible"
            nzOverlayClassName="watchlist-menu"
            [nzClickHide]="false"
            [nzBackdrop]="false"
          >
            <div class="btn-with-icon flex-align-center">
              <va-icon size="small" name="eye" class="mr-4"></va-icon>
              Watchlist
              <va-icon
                *ngIf="!watchlistMenuVisible"
                size="small"
                name="caret-down"
                class="right-icon"
                style="margin-left: 3px"
              ></va-icon>
              <va-icon
                *ngIf="watchlistMenuVisible"
                [isFontAwesome]="true"
                size="small"
                [name]="faCaretUp"
                class="ml-4 right-icon"
              ></va-icon>
            </div>
          </button>
          <button
            *ngIf="showCustomConsensus"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link"
            (click)="openCcModal()"
            [class.btn-secondary-header-cc]="pageName === 'mex'"
          >
            <div class="btn-with-icon flex-align-center">
              <va-icon size="small" name="edit"></va-icon> Custom Consensus
            </div>
          </button>
          <button
            *ngIf="showAlerts"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link"
            [class.btn-secondary-header-alerts]="pageName === 'mex'"
            nz-popover
            nzPopoverTitle="Edit Company Alert"
            [(nzPopoverVisible)]="visibleAlerts"
            nzPopoverTrigger="click"
            nzPopoverPlacement="bottomRight"
            nzPopoverOverlayClassName="alerts-popover-overlay"
            [nzPopoverContent]="alertsTemplate"
          >
            <div class="btn-with-icon flex-align-center">
              <va-icon
                size="small"
                name="bell"
                class="fa-lg alerts-icon"
              ></va-icon>
              Alerts
            </div>
          </button>

          <!-- Create New Watchlist on Watchlist Page -->
          <button
            *ngIf="showCreateNewWatchlist"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link"
            (click)="openWatchlistModal()"
          >
            <va-icon
              size="small"
              name="plus"
              class="create-watchlist-icon"
            ></va-icon>
            Create New Watchlist
          </button>
          <button
            *ngIf="
              sellsideBrokerShortName == undefined &&
              !isConsensusOnlyUser &&
              viewEntitlements &&
              showRequestEntitlements &&
              !showCorporateEntitlements
            "
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link"
            (click)="openShowRequestEntitlements()"
          >
            <va-icon size="small" name="unlock" class="fa-lg"></va-icon> Request
            Entitlement
          </button>
          <button
            *ngIf="
              sellsideBrokerShortName == undefined &&
              !isConsensusOnlyUser &&
              viewEntitlements &&
              showRequestNewBrokers &&
              !showCorporateEntitlements
            "
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header button-link"
            title="Request additional brokers be added to the platform"
            (click)="openShowRequestNewBrokers()"
          >
            <div class="btn-with-icon flex-align-center">
              <va-icon size="small" name="add-user" class="fa-lg"></va-icon>
              Request Broker
            </div>
          </button>
          <app-request-modal
            [visible]="isVisibleEntAndRequestBrokerModal"
            [(modalContext)]="modalContext"
            (onClose)="onCloseEntAndRequestBrokerModal()"
          ></app-request-modal>

          <!-- for new watchlist page-->
          <button
            *ngIf="showManageWatchlistButton"
            nz-button
            nzType="link"
            nzSize="large"
            class="btn-secondary-header button-link"
            (click)="openManageWatchlistModal()"
          >
            <va-icon size="small" name="cog" class="fa-lg"></va-icon> Manage
            Watchlist
          </button>

          <!-- Manage Watchlist Modal -->

          <app-manage-watchlist-modal
            [visible]="isVisibleManageWatchlistModal"
            (onClose)="closeManageWatchlistModal()"
          ></app-manage-watchlist-modal>

          <button
            *ngIf="showCreateCompsTable"
            [disabled]="disableActions"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header-comps"
            [ngClass]="{ inactive: disableActions }"
            style="position: relative; top: 30px; font-size: 16px"
            (click)="onCreateCompsTable()"
          >
            <va-icon
              size="small"
              name="plus"
              class="fa-lg create-watchlist-icon"
            ></va-icon>
            Create New
          </button>
          <button
            *ngIf="exportToExcelPages.includes(pageName)"
            nz-button
            nzType="link"
            nzSize="small"
            class="btn-secondary-header-export"
            [ngClass]="{ inactive: disableMexPageExport }"
            (click)="exportToExcel()"
            nz-dropdown
            [nzDropdownMenu]="menu"
            [nzTrigger]="'click'"
            [nzBackdrop]="false"
            [nzOverlayClassName]="'export-to-excel-dropdown-menu'"
            [nzOverlayStyle]="{
              display: pageName.toLowerCase() === 'mex' ? 'inherit' : 'none'
            }"
            [disabled]="disableMexPageExport"
            [title]="
              disableMexPageExport
                ? 'Export is not available for non Base currency in Company Data'
                : ''
            "
          >
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="onEteCurrentViewClick(eteModal)">
                  Default
                </li>
                <li nz-menu-item (click)="onEteCustomizeClick(eteModal)">
                  Customize
                </li>
              </ul>
            </nz-dropdown-menu>

            <va-icon size="small" name="file-excel" class="fa-lg"></va-icon>
            Export &nbsp;&nbsp;<va-icon
              size="small"
              name="caret-down"
              class="fa-lg right-icon"
              *ngIf="pageName.toLowerCase() === 'mex'"
            ></va-icon>
          </button>

          <div *ngIf="pageName.toLowerCase() === 'vsconsensus'">
            <button
              nz-button
              nzType="link"
              nzSize="small"
              class="btn-secondary-header-export"
              nz-popover
              nzPopoverTrigger="click"
              [nzPopoverContent]="exportOptionsTemplate"
              nzPopoverPlacement="bottomRight"
              [(nzPopoverVisible)]="exportOptVisible"
              nzPopoverOverlayClassName="comps-export-popover"
            >
              <va-icon size="small" name="file-excel"></va-icon>Export
            </button>

            <ng-template #exportOptionsTemplate>
              <div (click)="exportToExcel(1)" class="export-opt">Values</div>
              <div (click)="exportToExcel(0)" class="export-opt">
                Excel Add-In Formulas
              </div>
            </ng-template>
          </div>

          <button
            *ngIf="showCreateCharts"
            [disabled]="disableActions"
            nz-button
            nzType="link"
            nzSize="small"
            [ngClass]="{ inactive: disableActions }"
            class="btn-secondary-header-charts"
            style="font-size: 16px"
            (click)="onCreateCharts()"
          >
            <va-icon
              size="small"
              name="plus"
              class="create-watchlist-icon"
            ></va-icon>
            Create New
          </button>

          <div class="rightcontainer_labs_sub_header" *ngIf="isLabsPage">
            <span
              >VA Labs provides early access to experimental data sets, reports
              and capabilities.</span
            >
            <br />
            <span class="sub_title">
              <a href="mailto:labssupport@visiblealpha.com"
                >Share your feedback</a
              >
              and help us to deliver more useful features to you faster.</span
            >
          </div>
        </div>
      </div>
    </div>
    <app-subheader-formulabar
      *ngIf="fBarPages.includes(pageName)"
      (newFbarEvent)="setShowFbar($event)"
      [showNewFbar]="newFbarPages.includes(pageName)"
    ></app-subheader-formulabar>
  </div>
</nz-header>
<nz-header
  *ngIf="!showSecondaryHeader && !showCustomHeader"
  id="secondaryHeader"
  class="small"
>
  <div></div>
</nz-header>

<nz-header
  id="secondaryHeader"
  [ngClass]="{
    large: pageName.toLowerCase() === 'industry_metrics',
    pharma:
      pageName.toLowerCase() === 'biopharma-database' ||
      pageName.toLowerCase() === 'biopharma-drug',
    'comparative-analysis-header':
      pageName.toLowerCase() === 'comparative-analysis'
  }"
  *ngIf="showCustomHeader"
>
  <div
    style="height: 100%"
    nz-row
    nzType="flex"
    nzJustify="start"
    nzAlign="small"
    *ngIf="pageName.toLowerCase() === 'comparative-analysis'"
  >
    <div nz-col nzSpan="24">
      <div nz-row nzType="flex" nzJustify="space-between">
        <div nz-col nzSpan="22">
          <ng-container>
            <app-comparative-analysis-subheader></app-comparative-analysis-subheader>
          </ng-container>
        </div>
        <div nz-col>
          <app-global-user-settings-button
            class="global-settings-icon"
            [showText]="false"
          ></app-global-user-settings-button>
        </div>
      </div>
    </div>
  </div>
  <div
    style="height: 100%"
    nz-row
    nzType="flex"
    nzJustify="start"
    nzAlign="small"
    *ngIf="pageName.toLowerCase() === 'industry_metrics'"
  >
    <div nz-col nzSpan="24">
      <div nz-row nzType="flex" nzJustify="space-between">
        <div nz-col>
          <ng-container>
            <app-industry-subheader></app-industry-subheader>
          </ng-container>
        </div>
        <div nz-col>
          <app-global-user-settings-button
            class="global-settings-icon"
            [showText]="false"
          ></app-global-user-settings-button>
        </div>
      </div>
    </div>
    <app-subheader-formulabar
      (newFbarEvent)="setShowFbar($event)"
    ></app-subheader-formulabar>
  </div>
  <div
    style="height: 100%"
    nz-row
    nzType="flex"
    nzJustify="start"
    nzAlign="small"
    class="pharma-secondary-header"
    *ngIf="
      pageName.toLowerCase() === 'biopharma-database' ||
      pageName.toLowerCase() === 'biopharma-drug'
    "
  >
    <div nz-col nzSpan="24" class="pharma-export">
      <div nz-row nzType="flex" nzJustify="start" nzGutter="16">
        <div nz-col>
          <ng-container>
            <span id="secondaryHeaderTitle">
              <span (click)="routeToBioPharmaPage()">{{ title }}</span>
            </span>
          </ng-container>
        </div>
        <div nz-col>
          <ng-container>
            <div class="biopharma-search-container">
              <app-biopharma-search></app-biopharma-search>
            </div>
          </ng-container>
        </div>
      </div>
      <div nz-row nzType="flex" nzJustify="start" nzGutter="16">
        <div nz-col *ngIf="pageName.toLowerCase() === 'biopharma-drug'">
          <button
            nz-button
            nz-popover
            nzPopoverTrigger="click"
            [nzPopoverContent]="exportOptionsTemplate"
            [nzPopoverPlacement]="'bottomRight'"
            [(nzPopoverVisible)]="exportOptVisible"
            title="Export"
            nzType="link"
            nzSize="small"
            class="export-button"
            *ngIf="!isExportInProgress; else exportLoading"
          >
            <va-icon
              name="file-export"
              class="my-class"
              size="medium"
            ></va-icon>
            Export
          </button>
          <ng-template #exportOptionsTemplate>
            <div (click)="emitPharmaExportEvent()" class="export-opt">
              Values
            </div>
            <!-- <div class="export-opt disabled">Excel Add-In Formulas</div> -->
          </ng-template>
          <ng-template #exportLoading>
            <ng-template #indicatorTemplate>
              <button
                nz-button
                nzType="link"
                nzSize="small"
                class="export-button"
              >
                <va-icon
                  [isFontAwesome]="true"
                  size="small"
                  [name]="faSpinner"
                  [spin]="true"
                  class="spinner-icon"
                ></va-icon>
                Export
              </button>
            </ng-template>
            <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</nz-header>

<ng-template #alertsTemplate>
  <app-alerts-popover
    [params]="alertsParams"
    (onSet)="closeAlertsPopover($event)"
  ></app-alerts-popover>
</ng-template>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <app-watchlist-menu
    *ngIf="watchlistMenuVisible"
    (onOpenWatchlistModal)="openWatchlistModal()"
    [ticker]="ticker"
  ></app-watchlist-menu>
</nz-dropdown-menu>

<app-watchlist-modal
  *ngIf="isVisibleWatchlistModal"
  [visible]="isVisibleWatchlistModal"
  (onClose)="onCloseWatchlistModal()"
></app-watchlist-modal>

<app-export-to-excel
  #eteModal
  [isModalOpen]="isVisibleEteModal"
  [pageParams]="pageNavParams"
  (onClose)="onCloseEteModal()"
>
</app-export-to-excel>

<app-shortcuts-modal
  [isModalOpen]="isVisibleShortcutsModal"
  (onClose)="onCloseShortcutsModal($event)"
  [showNewFbar]="newFbarPages.includes(pageName)"
>
</app-shortcuts-modal>
